module.exports = __webpack_public_path__ + "static/media/postgresql.4e8fd8c4.png";